import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initLineAnimation() {
  console.log('Line Animation: Initializing...');
  
  // SVGパス要素を取得
  const lineElement = document.querySelector('.line-animation');
  
  if (!lineElement) {
    console.error('Line Animation: .line-animation element not found');
    return;
  }
  
  
  try {
    // パスの全長を取得
    const pathLength = lineElement.getTotalLength();
    
    // 初期状態を設定（線を非表示）
    gsap.set(lineElement, {
      strokeDasharray: pathLength,
      strokeDashoffset: pathLength,
      opacity: 1
    });
    
    console.log('Line Animation: Initial state set');
    
    // slide01からslide07までの要素を取得
    const slide01 = document.querySelector('#slide01');
    const slide07 = document.querySelector('#slide07');
    
    
    // スクロールトリガーでアニメーション
    ScrollTrigger.create({
      trigger: slide01,
      start: 'top bottom',
      endTrigger: slide07,
      end: 'bottom bottom',
      scrub: 1,
      onUpdate: (self) => {
        const progress = self.progress;
        const offset = pathLength - (pathLength * progress);
        
        gsap.set(lineElement, {
          strokeDashoffset: offset
        });
        
      },
    });
    
    console.log('Line Animation: ScrollTrigger created successfully');
    
  } catch (error) {
    console.error('Line Animation: Error during setup:', error);
  }
}